export const TIPOS_DOCUMENTO = [
  { value: '33', codigo: 33, label: 'Factura Electrónica' },
  { value: '34', codigo: 34, label: 'Factura Exenta Electrónica' },
  { value: '39', codigo: 39, label: 'Boleta Electrónica' },
  { value: '41', codigo: 41, label: 'Boleta Exenta Electrónica' },
];

// Notas de crédito/débito. Van aparte porque solo se ofrecen donde se piden
// explícitamente (buscador), no en los resúmenes de ventas.
export const TIPOS_NOTA = [
  { value: '56', codigo: 56, label: 'Nota de Débito Electrónica' },
  { value: '61', codigo: 61, label: 'Nota de Crédito Electrónica' },
];

const TODOS_LOS_TIPOS = [...TIPOS_DOCUMENTO, ...TIPOS_NOTA];

// Tipos que llevan datos del receptor: facturas y notas de crédito/débito.
const TIPOS_CON_RECEPTOR = ['33', '34', '56', '61'];

export const tieneReceptor = (codigo) => TIPOS_CON_RECEPTOR.includes(String(codigo));

export const labelTipoDocumento = (codigo) => {
  const tipo = TODOS_LOS_TIPOS.find((t) => String(t.codigo) === String(codigo));
  return tipo ? tipo.label : codigo;
};

export const tiposDisponiblesEmpresa = (empresas, extraFilter, { incluirNotas = false } = {}) => {
  const habilitados =
    Array.isArray(empresas) && Array.isArray(empresas[0]?.tiposdocumento)
      ? empresas[0].tiposdocumento
      : null;

  const disponibles = incluirNotas ? TODOS_LOS_TIPOS : TIPOS_DOCUMENTO;

  return disponibles.filter((t) => {
    if (habilitados && !habilitados.includes(t.codigo)) return false;
    if (extraFilter && !extraFilter(t)) return false;
    return true;
  });
};
